import React, { Component } from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import SiteConfig from '../../config/SiteConfig';
import packages from '../../data/packages';
import Countdown from '../Basic/Countdown';
import Sold from '../Basic/Sold';
import EFire from '../Emoji/EFire';
import EStar from '../Emoji/EStar';
import BuyBtn from './BuyBtn';
import Features from './Features';
import Methods from './Methods';
import Spacer from './Spacer';

// Component.
export default class App extends Component {
	render() {
		return (
			<Tables>
				{packages.map((pkg, i) => (
					<Table key={i}>
						<Stack {...pkg.options}>
							<Inner>
								<Header>
									<Title>
										{i === 1 && <EStar width="24" height="24" />}
										{pkg.title}
									</Title>
									<SubTitle>{pkg.subTitle}</SubTitle>
									{i === 1 && (
										<Img
											loading="lazy"
											className="lazyload"
											data-src={pkg.img}
											alt="Recommended!"
										/>
									)}
								</Header>
								<hr />
								<Features features={pkg.features} modules={pkg.modules} recommend={i === 1 && true} />
								<Spacer />
								<BuyBtn {...pkg.options} />
								{/* <AlreadySold>
									<ECake /> <strong>50% OFF</strong> on my Birthday today!!!
								</AlreadySold> */}
								<Spacer />
								<Methods />
								<Spacer />
								<AlreadySold>
									<EFire />{' '}
									<strong>
										<Sold /> ALREADY SOLD
									</strong>
								</AlreadySold>
								<Countdown date={SiteConfig.countdownDate} />
							</Inner>
						</Stack>
					</Table>
				))}
			</Tables>
		);
	}
}

// Styles.
const AlreadySold = styled.p`
	text-align: center;
	margin-bottom: ${props => props.theme.vr / 5}rem;
`;

const Tables = styled.div`
	display: table;
	width: 100%;
	margin: 3rem auto;
	max-width: 120rem;
`;
const Table = styled.div`
	display: table-cell;
	vertical-align: bottom;
	width: 50%;
	padding: ${props => props.theme.vr * 2}rem;
	position: relative;

	${rmq('1085')} {
		padding: 0;
	}
	${rmq('950')} {
		display: table;
		width: 100%;
		max-width: 50rem;
		margin: 0 auto;
	}
`;

const Stack = styled.div`
	/* For one table only */
	max-width: 75rem;
	margin: 5rem auto;
	padding: 1.6rem;
	background: ${props => (props.green ? props.theme.grgreen1 : props.theme.grgray1)};
	position: relative;

	${rmq('ml')} {
		padding: 1.6rem 0 0;
	}
	${rmq('ms')} {
	}

	&::before,
	&::after {
		content: '';
		background: ${props => (props.green ? props.theme.grgreen2 : props.theme.grgray2)};
		position: absolute;
		width: 90%;
		height: 90%;
		transform: rotateZ(5deg);
		z-index: -1;
		left: 0.5rem;
		top: -1rem;

		${rmq('1380')} {
			transform: rotateZ(3deg);
			left: -0.2rem;
			top: -1.5rem;
		}
		${rmq('950')} {
			transform: rotateZ(5deg);
			left: 0.5rem;
			top: -1rem;
		}
		${rmq('ls')} {
			transform: rotateZ(3deg);
			left: -0.2rem;
			top: -1.5rem;
		}
		${rmq('mm')} {
			width: 80%;
		}
		${rmq('ms')} {
			width: 75%;
		}
		${rmq('300')} {
			display: none;
		}
	}
	&::after {
		background: ${props => (props.green ? props.theme.grgreen1 : props.theme.grgray1)};
		transform: rotateZ(15deg);
		left: 3rem;
		top: 0.1rem;

		${rmq('1380')} {
			transform: rotateZ(5deg);
			left: 0.2rem;
			top: -1.4rem;
		}
		${rmq('ls')} {
			transform: rotateZ(5deg);
			left: 0.2rem;
			top: -1.4rem;
		}
		${rmq('950')} {
			transform: rotateZ(15deg);
			left: 3rem;
			top: 0.1rem;
		}
		${rmq('750')} {
			transform: rotateZ(5deg);
			left: 0;
			top: -1.4rem;
		}
		${rmq('mm')} {
			width: 80%;
		}
		${rmq('ms')} {
			width: 75%;
		}
		${rmq('300')} {
			display: none;
		}
	}

	&:hover {
		/* transform: scale(1.01); */
		transition: all 0.4s ease;
		box-shadow: 0 0 12rem 0 rgba(22, 22, 22, 0.4);
	}
`;
const Inner = styled.div`
	background: ${props => props.theme.white};
	padding: ${props => props.theme.vr * 1}rem;

	${rmq('ml')} {
		padding: 0.5rem;
	}
`;

const Header = styled.div`
	text-align: center;
	margin: 0 auto;
	padding: ${props => props.theme.vr * 1}rem;
	position: relative;

	${rmq('ls')} {
		padding: 0;
	}
`;

const Title = styled.h2`
	font-family: ${props => props.theme.f1};
	font-weight: 900;
	font-size: 5rem;
	margin: 0 auto;

	${rmq('ls')} {
		font-size: 4rem;
	}
	${rmq('300')} {
		font-size: 3rem;
	}
`;
const SubTitle = styled.h3`
	font-family: ${props => props.theme.f1};
	font-weight: 400;
	font-size: 3rem;
	margin: 0 auto;
	max-width: 65rem;

	${rmq('ls')} {
		font-size: 2.1rem;
	}
	${rmq('ml')} {
		font-size: 2rem;
	}
	${rmq('300')} {
		font-size: 1.6rem;
	}
`;

const Img = styled.img`
	position: absolute;
	width: 20rem;
	right: -10rem;
	top: -15rem;

	${rmq('1380')} {
		width: 15rem;
		left: -11rem;
		top: -3rem;
	}
	${rmq('t')} {
		right: -5rem;
		top: -12.5rem;
		left: unset;
	}
	${rmq('575')} {
		width: 10rem;
		right: 0rem;
		top: -11rem;
	}
`;
